module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "p-2 text-right w-100"
  }, [_c('a', {
    staticClass: "text-right",
    attrs: {
      "href": "http://www.ohiruneart.com/"
    }
  }, [_vm._v("© ohiruneart")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59932b03!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterBar.vue
// module id = 84
// module chunks = 1 2